import React from "react";
import HanziWriter from "hanzi-writer";
import { Container } from "react-bootstrap";

class WriteChinese extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      validChar:false,
      uid: Math.floor(Math.random() * Math.floor(10000)),
    };
  }
 
  componentDidMount() {
    this.writer = this.createHanziWritter(this.props.character, this.props.width);
    this.writer && this.writer.loopCharacterAnimation();
  }

  /**
   * Create a chinese charactor for display or test
   * @param {String} char, a single chinese character
   * @param {Integer} width, the width of the field to write the character
   */
  createHanziWritter = (char, width) => {
    let charDataLoader = null;
      try {
        charDataLoader = require("hanzi-writer-data/"+char);
        this.setState({validChar: true});
      } catch(error) {
        this.setState({validChar: false});
        console.log(error.message);
      }

    if (!charDataLoader) {
      return null;
    }

    const writer = HanziWriter.create('grid-background-target'+this.state.uid, char, {
      charDataLoader: function() {
        return charDataLoader;
      },
      width: width,
      height: width,
      padding: 5*width/100,
      strokeColor: "#EE00FF",
      radicalColor: "#168F16",
      delayBetweenLoops: 3000,
    });

    return writer;
  }

  displayGrid = (width) => {
    return (
      <svg 
          xmlns="http://www.w3.org/2000/svg"
          width={width} 
          height={width} 
          id={"grid-background-target"+this.state.uid}
        >
          <line x1="0" y1="0" x2={width} y2={width} stroke="#DDD" stroke-dasharray="10" stroke-width="2"/>
          <line x1={width} y1="0" x2="0" y2={width} stroke="#DDD" stroke-dasharray="10" stroke-width="2"/>
          <line x1={width/2} y1="0" x2={width/2} y2={width} stroke="#DDD" stroke-dasharray="10"stroke-width="2"/>
          <line x1="0" y1={width/2} x2={width} y2={width/2} stroke="#DDD" stroke-dasharray="10"stroke-width="2"/>
          <line x1="0" y1="0" x2={width} y2="000" stroke="#000" stroke-width="5"/>
          <line x1="0" y1="0" x2="0" y2={width} stroke="#000" stroke-width="5"/>
          <line x1="0" y1={width} x2={width} y2={width} stroke="#000" stroke-width="5"/>
          <line x1={width} y1="0" x2={width} y2={width} stroke="#000" stroke-width="5"/>
        </svg>
    );
  }

  notDisplayGrid = () => {
    return <div id={"grid-background-target"+this.state.uid}/>
  }

  render() {
    const width = this.props.width;
    return (
      <Container>
        {!this.state.validChar && <p>无法显示 "{this.props.character}".</p>}
        {
          this.props.displayGrid?
          this.displayGrid(width) :
            this.notDisplayGrid()
        }
      </Container>
    );
  }

  static defaultProps = {
    character: "无",
    width: 300,
    displayGrid: false
};
}

export default WriteChinese;